var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6875 16.875H16.3125C16.4091 16.875 16.5042 16.8501 16.5884 16.8027C16.6726 16.7553 16.7432 16.687 16.7933 16.6044C16.8435 16.5218 16.8715 16.4277 16.8747 16.3311C16.8779 16.2345 16.8561 16.1387 16.8116 16.053L9.49905 1.99047C9.45156 1.89914 9.37991 1.82259 9.29191 1.76917C9.20392 1.71575 9.10295 1.6875 9 1.6875C8.89706 1.6875 8.79609 1.71575 8.7081 1.76917C8.6201 1.82259 8.54845 1.89914 8.50095 1.99047L1.18845 16.053C1.14386 16.1387 1.12212 16.2345 1.12531 16.3311C1.1285 16.4277 1.15652 16.5218 1.20667 16.6044C1.25682 16.687 1.32741 16.7553 1.41163 16.8027C1.49585 16.8501 1.59086 16.875 1.6875 16.875ZM15.384 15.75H2.61602L2.6149 15.7482L8.99888 3.47142H9.00113L15.3851 15.7482L15.384 15.75ZM9.5625 6.75H8.4375V11.8125H9.5625V6.75ZM9 12.9375C8.83312 12.9375 8.66999 12.987 8.53124 13.0797C8.39248 13.1724 8.28434 13.3042 8.22048 13.4584C8.15662 13.6125 8.13991 13.7822 8.17246 13.9459C8.20502 14.1095 8.28538 14.2599 8.40338 14.3779C8.52138 14.4959 8.67172 14.5762 8.83539 14.6088C8.99906 14.6413 9.16871 14.6246 9.32289 14.5608C9.47707 14.4969 9.60884 14.3888 9.70155 14.25C9.79427 14.1113 9.84375 13.9481 9.84375 13.7812C9.84375 13.5575 9.75486 13.3429 9.59662 13.1846C9.43839 13.0264 9.22378 12.9375 9 12.9375Z",
    fill: "#FF4242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningAlt);
export default __webpack_public_path__ + "static/media/warning-alt.94fd46b76cbd6d86a8d9cad994b3b5d9.svg";
export { ForwardRef as ReactComponent };